<div id="main" class="internal">
  <app-restaurant-form
    [edit]="false"
    [ships]="ships"
    (restaurantCreated)="showResult($event)"
  ></app-restaurant-form>
</div>
